import authReducer from './slices/authSlice';
import clearerReducer from './slices/clearerSlice';
import dispatcherReducer from './slices/dispatcherSlice';

export const reducers = {
  auth: authReducer,
  clearer: clearerReducer,
  dispatcher: dispatcherReducer,
};
